module.exports = __webpack_public_path__ + "img/geometry-instruments.5fc5ccb1.svg";